import { datadogLogs } from "@datadog/browser-logs";

import { PickingContext } from "./pickingTypes";

export function getItemsIdsSortedByShelfList(ctx: PickingContext, isSkippedItemsList: boolean) {
  return isSkippedItemsList ? ctx.skippedItemsIdsSortedByShelf : ctx.itemsIdsSortedByShelf;
}

export function getPickingStateMap(ctx: PickingContext, isSkippedItem: boolean) {
  return isSkippedItem ? ctx.skippedItemsPickingState : ctx.itemsPickingState;
}

export function getItemPickingStateRef(
  itemId: string,
  ctx: PickingContext,
  isSkippedItem: boolean,
) {
  const pickingStateMap = getPickingStateMap(ctx, isSkippedItem);
  return pickingStateMap[itemId];
}

export function getItemWithPickingState(
  itemId: string,
  ctx: PickingContext,
  isSkippedItem: boolean,
) {
  const itemPickingStateRef = getItemPickingStateRef(itemId, ctx, isSkippedItem);
  const item = ctx.itemsMap[itemId];
  if (!itemPickingStateRef || !item) {
    return undefined;
  }
  return {
    ...itemPickingStateRef,
    item,
  };
}

export function getMissingItemsFromContext(ctx: PickingContext) {
  return Object.keys(ctx.itemsMap).flatMap((itemId) => {
    const item = ctx.itemsMap[itemId];
    const skippedState = ctx.skippedItemsPickingState[itemId];
    const regularState = ctx.itemsPickingState[itemId];
    const itemState = skippedState ? skippedState : regularState;
    if (itemState.pickedQuantity === item.quantity || !item.sku) {
      return [];
    }
    datadogLogs.logger.warn("picking.itemMarkedMissing", {
      itemId,
      sku: item.sku,
      itemQuantity: item.quantity,
      missingQuantity: item.quantity - itemState.pickedQuantity,
      usedStateSource: skippedState ? "skipped" : "regular",
      regularPickedQuantity: regularState?.pickedQuantity ?? null,
      regularState: regularState?.state ?? null,
      skippedPickedQuantity: skippedState?.pickedQuantity ?? null,
      skippedState: skippedState?.state ?? null,
    });
    return [
      {
        quantity: item.quantity - itemState.pickedQuantity,
        sku: item.sku,
      },
    ];
  });
}

export function getActiveItemFromContext(ctx: PickingContext, isSkippedItemsPickingState: boolean) {
  const [foundItemId] =
    Object.entries(
      isSkippedItemsPickingState ? ctx.skippedItemsPickingState : ctx.itemsPickingState,
    ).find(([, itemState]) => itemState.state === "PICKING") ?? [];
  if (!foundItemId) {
    return undefined;
  }
  const itemWithPickingState = getItemWithPickingState(
    foundItemId,
    ctx,
    isSkippedItemsPickingState,
  );
  if (!itemWithPickingState) {
    return undefined;
  }
  return { ...itemWithPickingState, isSkipped: isSkippedItemsPickingState };
}

export function selectNextItemInContext(ctx: PickingContext) {
  const getFirstPickableItemStateRef = (isSkippedItems: boolean) => {
    const pickingStateMap = getPickingStateMap(ctx, isSkippedItems);
    const itemsIdsSortedByShelf = getItemsIdsSortedByShelfList(ctx, isSkippedItems);
    const idleItemId = itemsIdsSortedByShelf.find((id) => pickingStateMap[id].state === "IDLE");
    return idleItemId ? pickingStateMap[idleItemId] : undefined;
  };

  const firstPickableItemStateRef =
    getFirstPickableItemStateRef(false) || getFirstPickableItemStateRef(true);

  if (firstPickableItemStateRef) {
    firstPickableItemStateRef.state = "PICKING";
  }
}
